import { defineStore } from 'pinia';
import { ref } from 'vue';
import { phone, email, landline, required } from '../../utils/validator';

/* eslint-disable max-len */
// eslint-disable-next-line import/prefer-default-export
export const useReservationStore = defineStore('reservation', () => {
    const currentStep = ref(1);
    const totalSteps = ref(4);
    const estateList = ref([]);
    const estateListResidences = ref([]);
    const estateListOffices = ref([]);
    const officeTypes = ref([]);
    const residenceTypes = ref([]);
    const propertyList = ref([]);
    const selectedType = ref('Residences');
    const selectedEstate = ref('');
    const selectedProperty = ref('');
    const hasPropertySelectionError = ref(false);
    const propertySelectionError = ref({
        estate: '',
        property: '',
    });
    function validatePropertySelection() {
        if (selectedEstate.value === '') {
            hasPropertySelectionError.value = true;
            propertySelectionError.value.estate = 'This field is required';
        }
        if (selectedProperty.value === '') {
            hasPropertySelectionError.value = true;
            propertySelectionError.value.property = 'This field is required';
        }
    }
    function resetPropertySelectionError() {
        hasPropertySelectionError.value = false;
        propertySelectionError.value = {
            estate: '',
            property: '',
        };
    }
    const personalDetail = ref({
        firstname: '',
        middlename: '',
        lastname: '',
        email: '',
        phone: '',
        landline: '',
    });
    const hasPersonalDetailError = ref(false);
    const personalDetailError = ref({
        firstname: '',
        middlename: '',
        lastname: '',
        email: '',
        phone: '',
        landline: '',
    });

    function nextStep() {
        if (currentStep.value >= totalSteps.value) {
            return;
        }
        if (currentStep.value === 1) {
            resetPropertySelectionError();
            validatePropertySelection();
            if (hasPropertySelectionError.value) {
                return;
            }
        }
        if (currentStep.value == 2) {
            validatePersonalDetail();
            if (hasPersonalDetailError.value === true) {
                return;
            }
        }
        currentStep.value++;
    }

    function prevStep() {
        if (currentStep.value == 1) {
            return;
        }
        currentStep.value--;
    }

    function setEstateList() {
        axios.get('/contact-us/getPropertyList/').then((response) => {
            estateList.value = response.data.estates;
            officeTypes.value = response.data.offices;
            residenceTypes.value = response.data.residence;
            estateListResidences.value = response.data.estatesResidences;
            estateListOffices.value = response.data.estatesOffices;
        });
    }

    function setPropertyList() {
        propertySelectionError.value.property = '';
        if (selectedType.value == 'Offices') {
            propertyList.value = officeTypes.value.filter(
                (property) => property.estate_id == selectedEstate.value
            );
        } else {
            propertyList.value = residenceTypes.value.filter(
                (property) => property.estate_id == selectedEstate.value
            );
        }
    }

    function setSelectedType(type) {
        propertySelectionError.value.property = '';
        propertySelectionError.value.estate = '';
        selectedEstate.value = '';
        selectedProperty.value = '';
        selectedType.value = type;
        if(type == 'Offices') {
            estateList.value = estateListOffices.value;
        }  else {
            estateList.value = estateListResidences.value;
        }
    }

    function setSelectedEstate(id) {
        propertySelectionError.value.estate = '';
        selectedProperty.value = '';
        selectedEstate.value = id;
        setPropertyList();
    }

    function setSelectedProperty(id) {
        setSelectedEstate(getEstateIDBasedOnPropertyID(id));
        selectedProperty.value = id;
    }

    function getEstateIDBasedOnPropertyID(property_id) {
        if (selectedType.value === 'Offices') {
            return officeTypes.value.filter(
                (property) => property.id == property_id
            )[0].estate_id;
        }
        return residenceTypes.value.filter(
            (property) => property.id == property_id
        )[0].estate_id;
    }

    function setDetailValue(key, value) {
        personalDetail.value[key] = value;
    }

    function resetDetailErrorMessage() {
        hasPersonalDetailError.value = false;
        personalDetailError.value = {
            firstname: '',
            middlename: '',
            lastname: '',
            email: '',
            phone: '',
            landline: '',
        };
    }

    function validatePersonalDetail() {
        resetDetailErrorMessage();
        const details = { ...personalDetail.value };
        for (let [key, value] of Object.entries(details)) {
            value = value.trim();
            if (key == 'phone' && phone(value) === false) {
                personalDetailError.value[key] = 'Invalid phone number';
                hasPersonalDetailError.value = true;
            }

            if (key == 'email' && email(value) === false) {
                personalDetailError.value[key] = 'Invalid email address';
                hasPersonalDetailError.value = true;
            }

            if (
                key == 'landline' &&
                required(value) == true &&
                landline(value) === false
            ) {
                personalDetailError.value[key] = 'Invalid landline number';
                hasPersonalDetailError.value = true;
            }

            if (['firstname', 'lastname', 'phone', 'email'].includes(key)) {
                if (value == '') {
                    personalDetailError.value[key] = 'This field is required';
                    hasPersonalDetailError.value = true;
                }
            }
        }
    }

    return {
        currentStep,
        totalSteps,
        nextStep,
        prevStep,

        estateList,
        setEstateList,
        officeTypes,
        residenceTypes,
        propertyList,
        selectedType,
        setSelectedType,
        selectedEstate,
        setSelectedEstate,
        selectedProperty,
        setSelectedProperty,
        hasPropertySelectionError,
        propertySelectionError,

        personalDetail,
        setDetailValue,
        personalDetailError,
        validatePersonalDetail,
        hasPersonalDetailError,
    };
});
